// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Utck","tabsBox":"styles_tabsBox__2aSuw","createButton":"styles_createButton__3xiME"};